<template>
  <div class="flex-row">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Row'
}
</script>
